import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, type User } from '@firebase/auth';
import { auth } from '../firebase';
import { Navigate } from 'react-router-dom';

export default function RedirectIfAuthed({ children }: { children: React.ReactNode }): React.ReactElement | null {
  const [user, setUser] = useState<User | null>(() => auth.currentUser);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  if (user) return <Navigate to="/home" replace />;
  return <>{children}</>;
}
